export default __webpack_public_path__ + "static/media/G0007.d7318cb7.png";